<div class="main-container lg-view">
	<ng-container *ngIf="isConfigurationView && !canConfigureRounds">		
		<div class="header">
			<h3>{{title}}</h3>			
		</div>
		<div class="job-form-container">
			<div class="unauthorized-user-feature">You don't have permission to manage this section</div>
		</div>
	</ng-container>	
	<ng-container *ngIf="!isConfigurationView || canConfigureRounds">
		<div class="header">
			<h3>{{title}}</h3>
			<div class="selection-header" *ngIf="onDemandForms?.length">
				<div>
					<a mat-button (click)="onSelectAllClick()">Select All</a>
					<a mat-button (click)="onGroupClick()" *ngIf="isConfigurationView">[{{ selectedProfileGroup.name }}]</a>
					<a mat-button (click)="onClearSelectionClick()">Clear Selection</a>
				</div>
				<div class="progress-status">
					<hr *ngIf="!isSaving">
					<mat-progress-bar mode="indeterminate" *ngIf="isSaving"></mat-progress-bar>
				</div>
			</div>
		</div>
		<ng-container *ngIf="onDemandForms?.length">

			<div class="job-form-container">
				<form [formGroup]="onDemandFormGroup">
					<div formArrayName="forms" class="forms">
						<div class="on-demand-item" *ngFor="let item of forms.controls; let i = index" [formGroupName]="i">
							<div class="form-button-details">
								<mat-checkbox (change)="onOnDemandCheckChange(item, $event)" formControlName="isIncluded">
								</mat-checkbox>
								<div>
									<div class="name">
										{{item.get('formName').value}}
									</div>
									<div class="details" *ngIf="item.get('lastCollectedOn')?.value !== null">
										Collected last time on
										{{moment.parseZone(item.get('lastCollectedOn').value).format('MM/DD/YYYY')}}
									</div>
								</div>
							</div>
							<div class="form-button-actions" [class.hidden]="!item.get('resourceTypeId').value">
								<button mat-icon-button class="add-icon" (click)="onMultipleAliasesClick(item);
									$event.preventDefault(); $event.stopPropagation(); addAliasModal.open({data: item})">
									<mat-icon [class.empty]="item.get('includedAliasesIds').value?.length === 0"
										class="action-icon" [matBadge]="item.get('includedAliasesIds').value?.length"
										matBadgeColor="#3dd598">menu</mat-icon>
								</button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</ng-container>

		<div class="empty-message-container" *ngIf="!onDemandForms?.length">There are no on-demand digital log forms!</div>
	</ng-container>
</div>

<div class="actions-container md-view" *ngIf="onDemandForms?.length !== 0 && (!isConfigurationView || canConfigureRounds)">
	<ng-container>
		<action-button *ngIf="!isConfigurationView" [icon]="ButtonIcons.Add" [name]="'Create'" (click)="addOnDemandForms()"></action-button>
	</ng-container>
</div>

<generic-modal class="asset-list-modal" #addAliasModal [hideOnBackdropClick]="false">
	<ng-template #modalHeading let-data="data">
		<div class="modal-heading">
			<span>{{ data.data.get('formName').value }}</span>
			<ng-container *ngIf="isSetupMode">
				<button class="add-alias" mat-icon-button (click)="onEditAsset()" [disabled]="isLoading">
					<span>
						<span *ngIf="!selectedOnDemandForm?.resourceTypeId">Add Asset</span>
						<span *ngIf="selectedOnDemandForm?.resourceTypeId">Add {{selectedOnDemandForm?.resourceType}}
							<span
								*ngIf="selectedOnDemandForm?.resourceSubTypeId">({{selectedOnDemandForm?.resourceSubType}})</span>
						</span>
						<mat-icon>add</mat-icon>
					</span>
				</button>
			</ng-container>
			<ng-container *ngIf="!isSetupMode && selectedOnDemandForm?.canConfigureAssets">
				<button class="setup" mat-icon-button (click)="onSetupClick()" [disabled]="isLoading">
					<span>
						<mat-icon>settings</mat-icon>
						<span>Setup</span>
					</span>
				</button>
			</ng-container>
		</div>
	</ng-template>

	<ng-template #modalBody let-data="data">
		<div class="main-container">
			<div class="modal-overlay" [class.overlay]="isLoading"></div>
			<app-loader *ngIf="isLoading"></app-loader>
			<ng-container>
				<div class="selection-header" *ngIf="!isSetupMode">
					<div>
						<a mat-button (click)="onSelectAliasesAllClick(data.data)">Select All</a>
						<a mat-button (click)="onClearAliasesSelectionClick(data.data)">Clear Selection</a>
					</div>
					<div class="progress-status">
						<hr *ngIf="!isSaving">
						<mat-progress-bar mode="indeterminate" *ngIf="isSaving"></mat-progress-bar>
					</div>
				</div>
				<form class="main-form" [formGroup]="aliasesFormGroup">
					<div class="alias-list" [class.mobile]="isMobileDevice"
						[class.noDateWidth]="data.data.get('hasNoLastCollectedDate').value" formArrayName="aliases">
						<div class="alias-table">
							<table #aliasTable class="alias-table">
								<thead>
									<tr>
										<th *ngIf="!isMobileDevice && !isSetupMode">Include</th>
										<th *ngIf="isMobileDevice && !isSetupMode">Incl.</th>
										<th *ngIf="!isMobileDevice && isSetupMode"></th>
										<th *ngIf="isMobileDevice && isSetupMode"></th>
										<th class="left-align" *ngIf="!selectedOnDemandForm?.resourceTypeId">Asset</th>
										<th class="left-align" *ngIf="selectedOnDemandForm?.resourceTypeId">
											{{selectedOnDemandForm?.resourceType}}
											<span
												*ngIf="selectedOnDemandForm?.resourceSubTypeId">({{selectedOnDemandForm?.resourceSubType}})</span>
										</th>
										<th *ngIf="isSetupMode">SN/Identifier</th>
										<th *ngIf="!isSetupMode">Last</th>
										<th *ngIf="isSetupMode">Active</th>
									</tr>
								</thead>
								<tbody>
									<ng-container *ngFor="let item of aliases.controls; let i = index"
										[formGroupName]="i">
										<tr>
											<td *ngIf="!isSetupMode">
												<mat-checkbox
													(change)="onAliasIncludeCheckChange(item, data.data, $event)"
													formControlName="isIncluded"></mat-checkbox>
											</td>
											<td *ngIf="isSetupMode"><button mat-icon-button
													[disabled]="!item.get('isActive').value"
													(click)="onEditAsset(item)">
													<mat-icon>edit</mat-icon>
												</button>
											</td>
											<td (click)="isSetupMode && onEditAsset(item)">
												<div class="alias-td">
													<span class="asset-info"
														[class.gray]="!item.get('isActive').value || (!isSetupMode && !item.get('canBeIncluded').value)"
														*ngIf="item.get('alias').value">
														{{item.get('alias').value}}
													</span>
													<span class="grayed" *ngIf="!selectedOnDemandForm?.resourceSubType && item.get('resourceSubType')?.value">
														({{item.get('resourceSubType')?.value}})
													</span>
													<span class="grayed" *ngIf="!item.get('resourceSubType')?.value && !isLoadingAssetSubTypes && assetSubTypes.length">
														(- n/a -)
													</span>
												</div>
											</td>
											<td *ngIf="isSetupMode" (click)="onEditAsset(item)">
												<span class="asset-info" [class.gray]="!item.get('isActive').value"
													*ngIf="item.get('aliasIdentifier').value">
													{{item.get('aliasIdentifier').value}}
												</span>
											</td>

											<td *ngIf="!isSetupMode">
												<span *ngIf="item.get('lastUpdatedOn').value !== null" class="date"
													[class.gray]="!item.get('isActive').value || !item.get('canBeIncluded').value">
													{{moment.parseZone(item.get('lastUpdatedOn').value).format('MM/DD/YYYY')}}
												</span>
												<span *ngIf="item.get('lastUpdatedOn').value === null" class="date"
													[class.gray]="!item.get('isActive').value || !item.get('canBeIncluded').value">
													<span>n/a</span>
												</span>
											</td>
											<td *ngIf="isSetupMode">
												<mat-checkbox [class.inactive-checkbox]="item.get('isActive').value"
													(click)="onAliasActiveCheckChange(item, data.data, $event)"
													formControlName="isActive"></mat-checkbox>
											</td>
										</tr>
									</ng-container>
								</tbody>
							</table>
						</div>
					</div>
				</form>
			</ng-container>
		</div>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-flat-button (click)="isSetupMode ? saveAliases() : onModalClose()"
			[disabled]="isLoading">Okay</button>
	</ng-template>
</generic-modal>

<generic-modal class="asset-modal" #editAssetModal [hideOnBackdropClick]="false">
	<ng-template #modalHeading let-data="data">
		<div class="modal-heading">
			<span *ngIf="!editAssetFormGroup.get('name')?.value">
				Create
			</span>
			<span *ngIf="editAssetFormGroup.get('name')?.value">
				Edit
			</span>
			<span *ngIf="selectedOnDemandForm?.resourceTypeId"> {{selectedOnDemandForm?.resourceType}}
				<span *ngIf="selectedOnDemandForm?.resourceSubTypeId"> ({{selectedOnDemandForm?.resourceSubType}})</span>
			</span>
			<span *ngIf="!selectedOnDemandForm?.resourceTypeId">Asset</span>
		</div>
	</ng-template>
	<ng-template #modalBody let-data="data">
		<div class="asset-form">
			<form class="main-form" [formGroup]="editAssetFormGroup">
				<div *ngIf="!isLoadingAssetSubTypes && !selectedOnDemandForm?.resourceSubTypeId && selectedOnDemandForm?.resourceTypeId && assetSubTypes?.length" class="asset-form-item">
					<mat-form-field>
						<mat-label>Select {{selectedOnDemandForm?.resourceType}} Type</mat-label>
						<mat-select formControlName="subType">
							<mat-option *ngFor="let subtType of assetSubTypes" [value]="subtType.id">
								{{subtType.name}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="asset-form-item">
					<mat-form-field>
						<mat-label>Name</mat-label>
						<input  [required]="true" matInput formControlName="name">
						<mat-error
							*ngIf="name.invalid && (name.dirty || name.touched)">{{getAssetNameErrorMessage()}}</mat-error>
					</mat-form-field>
				</div>
				<div class="asset-form-item">
					<mat-form-field>
						<mat-label>Make</mat-label>
						<input matInput formControlName="make">
					</mat-form-field>
				</div>
				<div class="asset-form-item">
					<mat-form-field>
						<mat-label>Model</mat-label>
						<input matInput formControlName="model">
					</mat-form-field>
				</div>
				<div class="asset-form-item">
					<mat-form-field>
						<mat-label>SN/Identifier</mat-label>
						<input matInput formControlName="identifier">
					</mat-form-field>
				</div>
				<div class="asset-form-item desc-field">
					<mat-form-field class="w-full">
						<mat-label>Description</mat-label>
						<textarea matInput formControlName="description" rows="3"></textarea>
					</mat-form-field>
				</div>
				<ng-container *ngIf="dynAttributes?.length > 0">
					<div class="section-sep">
						<span>Additional Attributes</span>
					</div>
					<div class="additional-attrs">
						<dynamic-form-group [attributes]="dynAttributes"></dynamic-form-group>
					</div>
				</ng-container>
				</form>
		</div>
	</ng-template>
	<ng-template #modalActions let-data="data">
		<button mat-flat-button [disabled]="isLoading" (click)="onCancelEditAsset()">Cancel</button>
		<button mat-flat-button color="primary" [disabled]="editAssetFormGroup.status==='INVALID' || isLoading"
			(click)="onSaveAsset()">Save</button>
	</ng-template>
</generic-modal>

<generic-modal class="group-list-modal" #groupListModal [hideOnBackdropClick]="true">
	<ng-template #modalHeading let-data="data">
		<div class="modal-heading">
			<span>My Work Groups</span>
		</div>
		<button mat-flat-button (click)="onGroupSelectorModalClose()" class="close-button">
		<mat-icon>close</mat-icon>
		</button>
	</ng-template>

	<ng-template #modalBody let-data="data">
		<div class="main-container">
			<div class="modal-overlay" [class.overlay]="isLoading"></div>
			<app-loader *ngIf="isLoading"></app-loader>
			<ng-container>
				<div class="actions">
				<button mat-flat-button 
					class="add-group"
					(click)="onAddGroupName()"
					[disabled]="!isConfigurationView">
					<mat-icon>add</mat-icon>
					<span>Add Group</span>
				</button>
				</div>
				<div class="group-list" *ngIf="digitalLogProfileGroups?.length; else noGroupsTemplate">
					<div class="group-item" *ngFor="let group of digitalLogProfileGroups">
						<div class="edit-action">
							<a mat-button (click)="onEditGroupName(group)">
								<mat-icon>edit</mat-icon>
							</a>
						</div>
						<div class="delete-action">
							<button mat-icon-button title="Delete"
								[disabled]="!isConfigurationView"
								(click)="onDeleteGroup(group); $event.stopPropagation();">
								<mat-icon>delete</mat-icon>
							</button>
						</div>
						<div class="group-name">
							<a mat-button (click)="onSelectProfileGroup(group)">{{ group.name }}</a>
						</div>
						<div class="group-forms-count" *ngIf="group.formsCount; else noForms">
							{{ group.formsCount }} form(s)
						</div>
						<ng-template #noForms>
							<div class="group-forms-count no-forms">
								- no forms -
							</div>
						</ng-template>
					</div>
				</div>
				<ng-template #noGroupsTemplate>
					<div class="no-groups">There are no groups available.</div>
				</ng-template>
			</ng-container>
		</div>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-flat-button (click)="onGroupSelectorModalClose()"
			>Close</button>
	</ng-template>
</generic-modal>

<generic-modal #deleteGroupConfirmationModal>
	<ng-template #modalHeading let-data="data">
		<strong>Delete Group Confirmation</strong>
	</ng-template>
	<ng-template #modalBody let-data="data">
		<div class="main-container">
			<p>
				Are you sure you want to delete this group?
			</p>
		</div>
	</ng-template>
	<ng-template #modalActions let-data="data">
		<button mat-flat-button class="primary" (click)="onDeleteGroupConfirmed(data);"
			[disabled]="!isConfigurationView">Confirm</button>
		<button mat-flat-button (click)="deleteGroupConfirmationModal.hide()">Cancel</button>
	</ng-template>
</generic-modal>

<generic-modal class="edit-group-modal" #editGroupNameModal>
	<ng-template #modalHeading let-data="data">
		<div class="modal-heading">
			<strong>Edit Group</strong>
		</div>
	</ng-template>
	<ng-template #modalBody let-data="data">
		<form class="main-form" [formGroup]="groupForm">
			<div class="group-form-item">
				<mat-form-field>
					<mat-label>Group Name</mat-label>
					<input matInput formControlName="name">
					<mat-error
							*ngIf="this.groupForm.get('name').invalid && (this.groupForm.get('name').dirty || this.groupForm.get('name').touched)">{{getGroupNameErrorMessage(this.groupForm.get('name'))}}</mat-error>
				</mat-form-field>
			</div>
		</form>
	</ng-template>
	<ng-template #modalActions let-data="data">
		<button mat-flat-button class="primary" (click)="onEditGroupNameConfirmed(data);"
			[disabled]="!isConfigurationView || groupForm.status==='INVALID' || IsEditGroupUnchanged(data) || isLoading">Save</button>
		<button mat-flat-button (click)="editGroupNameModal.hide()">Cancel</button>
	</ng-template>
</generic-modal>

<generic-modal class="add-group-modal" #addGroupModal>
	<ng-template #modalHeading let-data="data">
		<div class="modal-heading">
			<strong>Add New Group</strong>
		</div>
	</ng-template>
	<ng-template #modalBody let-data="data">
		<form class="main-form" [formGroup]="addGroupForm">
			<div class="group-form-item">
				<app-loader *ngIf="isLoading" [isInline]="true" [hasTransparency]="true"></app-loader>
				<mat-form-field>
					<mat-label>Name</mat-label>
					<input matInput formControlName="name">
					<mat-error
							*ngIf="this.addGroupForm.get('name').invalid && (this.addGroupForm.get('name').dirty || this.addGroupForm.get('name').touched)">{{getGroupNameErrorMessage(this.addGroupForm.get('name'))}}</mat-error>
				</mat-form-field>
			</div>
		</form>
	</ng-template>
	<ng-template #modalActions let-data="data">
		<button mat-flat-button class="primary" (click)="onAddGroupConfirmed();"
			[disabled]="!isConfigurationView || addGroupForm.status==='INVALID' || isLoading">Ok</button>
		<button mat-flat-button (click)="addGroupModal.hide()">Cancel</button>
	</ng-template>
</generic-modal>

<generic-modal #deleteLastGroupModal>
	<ng-template #modalBody let-data="data">
		<div class="main-container delete-last-group">
			<p>
				You can not delete this group as the app needs at least one group for this feature to properly work.
			</p>
			<p>You could rename the group if needed.</p>
		</div>
	</ng-template>
	<ng-template #modalActions let-data="data">
		<button mat-flat-button (click)="deleteLastGroupModal.hide()">Ok</button>
	</ng-template>
</generic-modal>